import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../../stores';
import * as Constants from '../../../Constants';
import { Property} from 'csstype';
import * as styles from '../DesignSettingsPanel.css';
import * as adminStyles from '../../AdminStyles.css';
import { IADropDown } from '../../../../dropDown/DropDown';
import { IAColorPicker } from '../../../../colorPicker/ColorPicker';
import { IAToggle } from '../../../../toggle/Toggle';
import { LocalizationService } from '../../../../../services/LocalizationService';
export interface ITopItemsSettingsPanelProps {
  navigatorStore?: NavigatorStore;
}

@inject('navigatorStore')
@observer
export default class TopItemsSettingsPanel extends React.Component<ITopItemsSettingsPanelProps, {}> {
  public render(): JSX.Element {
    return (
      <div className={styles.pivotContentItem}>
        <IAColorPicker
          label={new LocalizationService().strings.Navigator_Design_TextColor}
          color={this.props.navigatorStore.navigator.design.topItems.textColor}
          onChange={(color: string) => this.props.navigatorStore.setTopItemTextColor(color)}
          showClearButton={false}
        />
        <IAColorPicker
          label={new LocalizationService().strings.Navigator_Design_BackgroundColor}
          color={this.props.navigatorStore.navigator.design.topItems.backgroundColor}
          onChange={(color: string) => this.props.navigatorStore.setBurgerMenuBackgroundColor(color)}
          showClearButton={false}
        />
        <IAColorPicker
          label={new LocalizationService().strings.Navigator_Design_HighlightColor}
          color={this.props.navigatorStore.navigator.design.topItems.highlightColor}
          onChange={(color: string) => this.props.navigatorStore.setBurgerMenuHighlightColor(color)}
          showClearButton={false}
        />
        {this.props.navigatorStore.navigator?.design?.menuBar?.layout === 'burger' && (
          <IAColorPicker
            label={new LocalizationService().strings.Navigator_Design_HighlightTextColor}
            color={this.props.navigatorStore.navigator.design.topItems.highlightTextColor}
            onChange={(color: string) => this.props.navigatorStore.setBurgerMenuHighlightTextColor(color)}
            showClearButton={false}
          />
        )}
        <div className={adminStyles.panelDivider} />
        <IADropDown
          label={new LocalizationService().strings.Navigator_Design_FontSize}
          selectedOption={this.props.navigatorStore.navigator.design.topItems.fontSize as string}
          options={Constants.FONT_SIZES}
          onChange={(fontSize: Property.FontSize<number>) => this.props.navigatorStore.setTopItemFontSize(fontSize)}
          style={{ width: 155, float: "left"  }}
          borderRadius={5}
        />
        <IADropDown
          label={new LocalizationService().strings.Navigator_Design_FontWeight}
          selectedOption={this.props.navigatorStore.navigator.design.topItems.fontWeight as string}
          options={Constants.FONT_WEIGHTS}
          onChange={(fontWeight: string) => this.props.navigatorStore.setTopItemFontWeight(fontWeight)}
          style={{ width: 155, float: "left" , clear: 'none', marginLeft: 20 }}
          borderRadius={5}
        />
        <IADropDown
          label={new LocalizationService().strings.Navigator_Design_TextTransform}
          selectedOption={this.props.navigatorStore.navigator.design.topItems.textTransform}
          options={Constants.TEXT_TRANSFORMS}
          onChange={(textTransform: Property.TextTransform) =>
            this.props.navigatorStore.setTopItemTextTransform(textTransform)
          }
          style={{ width: 155, float: "left"  }}
          borderRadius={5}
        />
        <IADropDown
          label={new LocalizationService().strings.Navigator_Design_LetterSpacing}
          selectedOption={this.props.navigatorStore.navigator.design.topItems.letterSpacing}
          options={Constants.LETTER_SPACING}
          onChange={(letterSpacing: string) => this.props.navigatorStore.setTopItemLetterSpacing(letterSpacing)}
          style={{ width: 155, float: "left" , clear: 'none', marginLeft: 20 }}
          borderRadius={5}
        />
        {this.props.navigatorStore.navigator?.design?.menuBar?.layout == 'horizontal' && (
          <IADropDown
            label={new LocalizationService().strings.Navigator_Design_Margin}
            selectedOption={
              this.props.navigatorStore.navigator.design.topItems.margin == undefined
                ? '0'
                : this.props.navigatorStore.navigator.design.topItems.margin
            }
            options={Constants.INDENT}
            onChange={(margin: string) => this.props.navigatorStore.setTopItemMargin(margin)}
            style={{ width: 155, float: "left"  }}
            borderRadius={5}
          />
        )}
        {this.props.navigatorStore.navigator?.design?.menuBar?.layout == 'burger' && (
          <div>
            <div className={adminStyles.panelDivider} />
            <IAToggle
              label={new LocalizationService().strings.Navigator_Design_LineShow}
              checked={this.props.navigatorStore.navigator.design.topItems.showLine}
              color={this.props.navigatorStore.adminColor}
              onChange={() => {
                this.props.navigatorStore.toggleTopItemLine();
                this.forceUpdate();
              }}
            />
            <IADropDown
              label={new LocalizationService().strings.Navigator_Design_LineThickness}
              selectedOption={this.props.navigatorStore.navigator.design.topItems.lineThickness}
              options={Constants.LINE_THICKNESS}
              onChange={(lineThickness: string) => this.props.navigatorStore.setTopItemLineThickness(lineThickness)}
              style={{ width: 155, clear: 'none', marginLeft: 20 }}
              borderRadius={5}
            />
          </div>
        )}
        <div className={adminStyles.panelDivider} />
        <IAColorPicker
          label={new LocalizationService().strings.Navigator_Design_IconColor}
          color={this.props.navigatorStore.navigator.design.topItems.iconColor}
          onChange={(color: string) => this.props.navigatorStore.setTopItemIconColor(color)}
          showClearButton={false}
        />
        <div className={adminStyles.panelDivider} />
      </div>
    );
  }
}
